import axios from "axios"
import { decodeJwtClaims } from "./jwtClaims"

export const api = axios.create({
  //withCredentials: true,
  baseURL: process.env.REACT_APP_SPACE_API_HOSTNAME + "/api/v1",
//   baseURL: "https://yourdomain.com/api/v1",
})

// Attach the XHeaderSession headers the smartdeviceplatformagg BFF expects on the
// authenticated HardwareTest endpoints (/all, /search, /types are now
// [Authorize(AuthenticationSchemes="XHeaderSession")], fail-closed 401). The session
// id + identity live as claims inside the login JWT stored at localStorage 'authToken'
// (admin-portal-backend getToken: SessionId / sub / email). The BFF validates the
// session against the shared Redis store, so reading the claims client-side is enough.
api.interceptors.request.use((config) => {
  const claims = decodeJwtClaims(localStorage.getItem("authToken"))
  if (claims) {
    config.headers = config.headers || {}
    config.headers["XSessionId"] = claims.SessionId
    config.headers["XUserId"] = claims.sub
    config.headers["XUserEmail"] = claims.email
  }
  return config
})

// defining a custom error handler for all APIs
const errorHandler = (error) => {
  const statusCode = error.response?.status

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.error(error)
  }

  return Promise.reject(error)
}

// registering the custom error handler to the
// "api" axios instance
api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error)
})